import * as React from 'react';
import { useCallback } from 'react';

import { UitkPrimaryButton, UitkButtonSize } from 'uitk-react-button';

import analyticsWrapper from 'utility/analytics-wrapper';
import { useStores } from 'utility/hooks';
import { trackSearchFormAnalytics } from 'utility/analytics';
import { InteractableFieldComponentProps } from 'types/shared';

export const SearchFormButton = ({ onFieldInteraction }: InteractableFieldComponentProps) => {
  const {
    analytics,
    searchCriteriaStore,
    routeStore,
    searchFormStore,
    context,
    dialogsStore,
    sortFilterStore,
    searchResults
  } = useStores();
  const { setIsSubsequentialSearch } = searchResults;
  const searchButtonOnClick = useCallback(() => {
    onFieldInteraction && onFieldInteraction();
    searchCriteriaStore.clearSortFilterSearchCriteria();
    searchFormStore.clearErrorRef();

    const valid = searchFormStore.validate(analytics);

    if (!valid) {
      return;
    }
    setIsSubsequentialSearch(true);

    searchCriteriaStore.syncWithSearchFormStore(searchFormStore);
    trackSearchFormAnalytics(
      analytics,
      searchFormStore.searchForm.searchActionAnalytics,
      searchFormStore.selectedTripTypeOptionItem.tripType
    );
    sortFilterStore.loading = true;
    searchCriteriaStore.triggerSearch(routeStore, context, false);
    analyticsWrapper.resetAnalyticsPayLoad(analytics);
    dialogsStore.resetForcedChoiceDisplayedCounter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, searchCriteriaStore, routeStore, searchFormStore, context]);

  return (
    <UitkPrimaryButton
      name="searchButton"
      text={searchFormStore.searchForm.searchAction}
      size={UitkButtonSize.LARGE}
      isFullWidth={true}
      onClick={searchButtonOnClick}
      data-test-id="search-form-button"
    />
  );
};
